import PropTypes from 'prop-types';
import WrappedPudoAddress from './WrappedPudoAddress/WrappedPudoAddress';
import WrappedResidentialAddress from './WrappedResidentialAddress/WrappedResidentialAddress';

export default function CollapsedDeliveryAddress(props) {
  return (
    props.isPudoSelected
      ? (
        <WrappedPudoAddress />
      ) : (
        <WrappedResidentialAddress />
      )
  );
}

CollapsedDeliveryAddress.propTypes = {
  isPudoSelected: PropTypes.bool.isRequired,
};
